import { Schema } from "@mwater/expressions"
import { SiteDesign } from "./SiteDesign"

/** Creates a schema from a domain db */
export const createSchema = (siteDesign: SiteDesign) => {
  return new Schema({ tables: siteDesign.tables })
}
